export default __webpack_public_path__ + "static/media/signup-3.468084f8.svg";